import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/atoms/Modal";
import ClinvarContainer from "./ClinvarContainer";
import { getUserClinvarApiKey } from "../../state/selectors/ClinvarSubmissions.selectors";
import isLoggedIn from "../../common/helpers/isUserLoggedIn";
import { eventTrack } from "../../common/helpers/helpers";
import { ANALYTICS_CATEGORIES } from "../../components/cards/common/constants";

const ClinvarButton = ({ type, analyticsLocation }) => {
  const [open, setOpen] = useState(false);
  const clinvarApiKey = useSelector(getUserClinvarApiKey);
  const isGene = useSelector((state) => Boolean(state.variantResult?.gene_id));
  const isUserLoggedIn = isLoggedIn();
  const handleButtonClick = () => {
    eventTrack(
      ANALYTICS_CATEGORIES.CLINVAR,
      "Form opened from",
      analyticsLocation
    );
    setOpen(true);
  };

  const close = useCallback(() => setOpen(false), []);

  return !isGene ? (
    <div
      className={type === "primary" ? "" : "saph-white-ghost"}
      data-testid="clinvar-button-renders"
    >
      <button
        type="button"
        data-tooltip="Make a ClinVar submission"
        data-helptour="Submit variant information to ClinVar"
        data-helptour-version="10.2.1"
        data-helppos="0"
        className={`help-tour wizard-Clinvar ${
          type === "primary"
            ? "btn btn-success"
            : "tw-bg-transparent tw-border-0 tw-outline-none tw-p-0"
        }`}
        onClick={handleButtonClick}
        data-testid="test-clinvar-button"
      >
        <FontAwesomeIcon
          icon={faFileImport}
          fixedWidth={true}
          className="tw-text-white tw-mr-1"
        />
        Submit to ClinVar
      </button>
      <Modal
        onRequestClose={close}
        isOpen={open}
        alertOnClose={Boolean(clinvarApiKey && isUserLoggedIn)}
      >
        <div className="tw-container tw-p-6">
          <ClinvarContainer setOpen={setOpen} />
        </div>
      </Modal>
    </div>
  ) : null;
};

ClinvarButton.propTypes = {
  type: PropTypes.oneOf(["primary", "inverted"]),
  analyticsLocation: PropTypes.string,
};

ClinvarButton.defaultProps = {
  type: "primary",
  analyticsLocation: "",
};

export default React.memo(ClinvarButton);
